<template>
  <FormItem
    v-bind="{label, prop, labelWidth}"
    class="date-select"
  >
    <Row>
      <Col :xs="8">
        <VueSelect
          class="base-vue-select hide-clear date"
          max-height="200px"
          transition="none"
          :placeholder="placeholder.year"
          :value="val.year"
          :options="years"
          :disabled="disabled"
          :searchable="false"
          :on-change="handleYearChange"
        />
      </Col>
      <Col :xs="8">
        <VueSelect
          class="base-vue-select hide-clear date"
          :placeholder="placeholder.month"
          max-height="200px"
          transition="none"
          :value="val.month"
          :options="months"
          :disabled="disabled"
          :searchable="false"
          :filterable="false"
          :on-change="handleMonthChange"
        />
      </Col>
      <Col :xs="8">
        <VueSelect
          v-if="val.day !== undefined"
          class="base-vue-select hide-clear date"
          max-height="200px"
          transition="none"
          :placeholder="placeholder.day"
          :value="val.day"
          :options="days"
          :disabled="disabled"
          :searchable="false"
          :filterable="false"
          :on-change="handleDayChange"
        />
      </Col>
    </Row>
  </FormItem>
</template>

<script>
  import { Row, Col, FormItem } from 'iview';
  import VueSelect from 'vue-select';
  import getYear from 'date-fns/get_year';

  export default {
    components: { FormItem, VueSelect, Row, Col },
    props: {
      prop: {
        type: String,
        default: ''
      },
      label: {
        type: String,
        default: ''
      },
      labelWidth: {
        type: Number,
        default: null
      },
      value: {
        type: Object,
        default: () => ({ year: '', month: '', day: '' })
      },
      age: {
        type: Boolean,
        default: false
      },
      disabled: {
        type: Boolean,
        default: false
      },
      isRE: {
        type: Boolean,
        default: false
      },
      placeholder: {
        type: Object,
        default: () => ({
          year: '選擇年份',
          month: '選擇月份',
          day: '選擇日期' 
        })
      }
    },
    data() {
      return {
        dateObj: new Date(),
      };
    },
    computed: {
      val() {
        return Object.keys(this.value).reduce((acc, key) => {
          const optionKey = `${key}s`;
          const val = this.value[key];
          const optionVal = this[optionKey].find(op => op.value === val) || '';
          return { ...acc, [key]: optionVal };
        }, {});
      },
      years() {
        const { age, isRE } = this;
        const year = getYear(new Date());
        const length = age ? 60 : 30;
        const ageLimit = 20;
        let startAt = year - length;

        if (age) {
          startAt -= ageLimit;
        }

        if (isRE) {
          startAt -= 1911;
        }

        const options = Array.from({ length }, (x, i) => {
          const value = `${startAt + (i + 1)}`;
          return { value, label: `${value}年`, key: 'year' };
        });
        return options.slice().reverse();
      },
      months() {
        return Array.from({ length: 12 }, (x, i) => {
          const value = `${i + 1}`;
          return { 
            value: value.length < 2 ? `0${value}` : value, 
            label: `${value}月`, 
            key: 'month' 
          };
        });
      },
      days() {
        // const { value: { year, month } } = this;
        // const y = parseInt(year, 10);
        // const m = (parseInt(month, 10)) - 1;
        // const length = getDaysInMonth(y, m);
        return Array.from({ length: 31 }, (x, i) => {
          const value = `${i + 1}`;
          return { 
            value: value.length < 2 ? `0${value}` : value,
            label: `${value}日`,
            key: 'day'
          };
        });
      }
    },
    methods: {
      handleYearChange(optionObj) {
        if (!optionObj) return this.handleReset('year');
        this.handleSelectChange(optionObj);
      },
      handleMonthChange(optionObj) {
        if (!optionObj) return this.handleReset('month');
        this.handleSelectChange(optionObj);
      },
      handleDayChange(optionObj) {
        if (!optionObj) return this.handleReset('day');
        this.handleSelectChange(optionObj);
      },
      handleSelectChange(optionObj) {
        const { key, value: optionVal } = optionObj;
        const date = { ...this.value, [key]: optionVal };
        this.$emit('input', date);
      },
      handleReset(key) {
        this.$emit('input', { ...this.value, [key]: '' });
      }
    },
  };
</script>